import React, {PureComponent} from "react";
import {withTranslation} from "react-i18next";
import ReactTooltip from "react-tooltip";
import {Modal} from "react-responsive-modal";
import Alert from "react-s-alert";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

class MarshallWarningComponent extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            activeWarnings: [],
            showClearModal: false,
            transitionCountdown: 0,
            transitionFlag: 0,
        };

        this.updateStatus = this.updateStatus.bind(this);
        this.handleCloseTransitionModal = this.handleCloseTransitionModal.bind(this);
        this.handleChangeCountdown = this.handleChangeCountdown.bind(this);
        this.handleChangeTransitionFlag = this.handleChangeTransitionFlag.bind(this);
        this.handleMakeTransitionFlag = this.handleMakeTransitionFlag.bind(this);
        this.buildWarnings = this.buildWarnings.bind(this);
    }

    // LIFE CYCLE
    componentDidMount() {
        this.buildWarnings();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (JSON.stringify(prevProps.sessionStatus) !== JSON.stringify(this.props.sessionStatus)) {
            this.buildWarnings();
        }
    }

    // HANDLERS
    updateStatus(index) {
        let newState = [];
        if (index < 0) {
            // CLEAR FULL-COURSE
            for (let i = 0; i < this.props.marshallPosts.length; i++) {
                newState.push(0);
            }
            this.setState({
                showClearModal: true,
            });
        } else {
            // CLEAR PARTIAL
            for (let i = 0; i < this.props.marshallPosts.length; i++) {
                if (i === index) {
                    newState.push(0);
                } else {
                    newState.push(this.props.sessionStatus[i] ? this.props.sessionStatus[i].id : 0);
                }
            }

            this.props.sendFlag(newState, null, null, null, null, null, null, (err, ok) => {
                if (err) {
                    Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("actionError") + '!</span>', {
                        position: 'top-right',
                        effect: 'genie',
                        beep: false,
                        timeout: 5000,
                        offset: 150
                    });
                } else {
                    Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("sessionCleared") + '!</span>', {
                        position: 'top-right',
                        effect: 'genie',
                        beep: false,
                        timeout: 5000,
                        offset: 150
                    });
                }
            });
        }
    }

    handleCloseTransitionModal() {
        this.setState({
            showClearModal: false,
        }, () => {
            this.setState({
                transitionCountdown: 0,
                transitionFlag: 0,
            });
        });
    }

    handleChangeCountdown(e) {
        this.setState({
            transitionCountdown: parseInt(e.target.value),
        });
    }

    handleChangeTransitionFlag(e) {
        e.persist();
        this.setState({
            transitionFlag: parseInt(e.target.value),
        });
    }

    handleMakeTransitionFlag(e) {
        let temp = [];
        let clearingState = false;
        if (this.state.transitionCountdown === 0 && this.state.transitionFlag === 0) {
            // IS MAKING TRANSITION TO A CLEAR SESSION STATE
            for (let i = 0; i < this.props.marshallPosts.length; i++) {
                clearingState = true;
                temp.push(0);
            }
        } else {
            for (let i = 0; i < this.props.marshallPosts.length; i++) {
                temp.push(this.props.sessionStatus[0].id);
            }
        }
        this.props.sendFlag(temp, (clearingState ? 0 : this.props.sessionStatus[0].id), null, null, this.state.transitionCountdown, null, this.state.transitionFlag, () => {
            this.setState({
                transitionCountdown: 0,
                transitionFlag: 0,
            });
            this.handleCloseTransitionModal();
        });
    }

    // RENDER
    buildWarnings() {
        let temp = [];
        // Check if is full-course
        let is_full_course = true;
        for (let i = 0; i < this.props.marshallPosts.length; i++) {
            if (this.props.sessionStatus[i]) {
                if (this.props.sessionStatus[i].is_full_course !== 1) {
                    is_full_course = false;
                    break;
                }
            }
        }

        if (this.props.sessionStatus.length > 0 && this.props.sessionStatus[0] && is_full_course) {
            temp.push(
                <SingleWarning
                    key={this.props.sessionStatus[0].id}
                    flagObj={this.props.sessionStatus[0]}
                    updateStatus={this.updateStatus}
                    marshallPosts={null}
                    enableClick={this.props.enableClick}
                    isSingleVehicle={this.props.isSingleVehicle}
                    index={-1}
                    t={this.props.t}
                    hasTooltip={this.props.hasTooltip}
                />
            );
        } else {
            for (let i = 0; i < this.props.marshallPosts.length; i++) {
                if (this.props.sessionStatus[i]) {
                    let sessionStatus = {...this.props.sessionStatus[i]};
                    sessionStatus.is_full_course = 0;
                    temp.push(
                        <SingleWarning
                            key={sessionStatus + "_" + i}
                            flagObj={sessionStatus}
                            updateStatus={this.updateStatus}
                            marshallPosts={this.props.marshallPosts}
                            isSingleVehicle={this.props.isSingleVehicle}
                            enableClick={this.props.enableClick}
                            index={i}
                            t={this.props.t}
                            hasTooltip={this.props.hasTooltip}
                        />
                    );
                }
            }
        }

        if (temp.length === 0) {
            temp.push(
                <div key={"noWarningsActive"} className={"col-xs-10"} style={{margin: "auto", padding: 10, textAlign: "left"}}>
                    <div className={"App_white_text"} style={{height: "100%"}}>
                        {this.props.t("noActiveWarnings").toUpperCase()}
                    </div>
                </div>
            );
        }

        this.setState({
            activeWarnings: temp,
        });
    }

    render() {
        if (this.props.marshallPosts) {
            return (
                <>
                    {this.state.activeWarnings}
                    {this.props.isFlagPanel ? (
                        <Modal open={this.state.showClearModal}
                               onClose={this.handleCloseTransitionModal}
                               center={false}
                               classNames={{modal: "small-modal"}}
                               showCloseIcon={false}
                        >
                            <div className={"modal-header"}>
                                <div className={"modal-title"}>
                                    <span className={"App_black_text"} style={{fontSize: 25}}><b>{this.props.t("clearingFullCourse")}</b></span>
                                </div>
                            </div>
                            <div className={"modal-body"}>
                                <div className={"row"}>
                                    <div className={"col-xs-6"}>
                                        <label className={"App_black_text"}>{this.props.t("countdown")}</label>
                                        <input type={"text"}
                                               className={"form-control App_black_text"}
                                               placeholder={this.props.t("valueInSeconds")}
                                               onChange={this.handleChangeCountdown}
                                        />
                                    </div>
                                    <div className={"col-xs-6"}>
                                        <label className={"App_black_text"}>{this.props.t("transitionFlag")}</label>
                                        <select className={"form-control"} onChange={this.handleChangeTransitionFlag}>
                                            <option value={0}/>
                                            {!this.props.isSingleVehicle ? (
                                                this.props.fullCourseFlags.map((flag) => {
                                                    return (
                                                        <option key={flag.id} value={flag.id}>{flag["desc_" + localStorage.getItem("i18nextLng")]}</option>
                                                    );
                                                })
                                            ) : null}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <button
                                    onClick={this.handleMakeTransitionFlag}
                                    className={"btn App_white_text"}
                                    style={{background: "#ff0003", color: "#FFFFFF"}}
                                    disabled={!this.state.transitionCountdown && this.state.transitionFlag > 0}
                                >{this.props.t("makeTransition")}
                                </button>
                                <button
                                    onClick={this.handleCloseTransitionModal}
                                    className={"btn App_white_text"}
                                    style={{background: "#ff0003", color: "#FFFFFF"}}
                                >{this.props.t("close")}
                                </button>
                            </div>
                        </Modal>
                    ) : null}
                </>
            );
        } else {
            return null;
        }
    }
}

class SingleWarning extends PureComponent {

    constructor(props) {
        super(props);
        this.handleFlagClick = this.handleFlagClick.bind(this);
    }

    handleFlagClick() {
        if (this.props.enableClick) {
            if (!this.props.isSingleVehicle) {
                this.props.updateStatus(this.props.index);
            }
        }
    }

    render() {
        return (
            <div
                data-tip={true}
                data-for={"session_p" + this.props.flagObj.id}
                className={(this.props.flagObj.is_full_course ? "col-xs-12 " : "col-xs-1 ") + "flag-container"}
            >
                <div
                    className={(this.props.isSingleVehicle ? "" : "blink ") + "w3-animate-fading vcenter flag-shadow"}
                    style={{backgroundImage: "url(" + serverIP + ":" + backendPort + "/images/flags/" + this.props.flagObj.src + ")", backgroundSize: "contain"}}
                    onClick={this.handleFlagClick}
                >
                    {!this.props.flagObj.is_full_course ? (
                        <div className={"flag-legend"}>
                            <span className={(this.props.isSingleVehicle && !this.props.isFlagPanel) ? "App_white_text" : "App_streamText"}>{this.props.marshallPosts[this.props.index].name}</span>
                        </div>
                    ) : (
                        <div className={"flag-legend"}>
                            <span className={(this.props.isSingleVehicle && !this.props.isFlagPanel) ? "App_white_text" : "App_streamText"}>{this.props.t("stateFullCourse")}</span>
                        </div>
                    )}
                </div>
                {this.props.hasTooltip ? (
                    <ReactTooltip id={"session_p" + this.props.flagObj.id} type={"light"} place={"bottom"}>
                        <span className={"toolTipStyle"}>{this.props.flagObj["desc_" + localStorage.getItem("i18nextLng")]}</span>
                    </ReactTooltip>
                ) : null}
            </div>
        );
    }
}

export default withTranslation("translations")(MarshallWarningComponent);
